import axios from 'axios';
import * as endpoint from '../../../endpoint';
// import * as actionTypes from '../../../actionTypes';
import {
  checkCancelToken,
  consolelog,
  delCancelToken,
} from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * 報告書の詳細データを取得する。
 * 取得したデータは、reduxで管理する。
 *
 * @param {string} apiToken - APIトークン
 * @param {string} groupId - グループID。このグループに紐づく報告書一覧を取得する。
 * @param {string} reportId - 報告書ID。
 * @returns {Function} dispatch - Redux dispatch関数
 */
const getReportDetail = (apiToken, groupId, reportId) => dispatch => {
  consolelog('[API CALL] getReportDetail()', apiToken);
  configureAxiosForJSON(apiToken);
  const { cancelToken, cancelTokenKey } = createCancelToken('getReport');
  const url = endpoint.API_GET_REPORT_DETAIL.replace(
    '{groupId}',
    groupId,
  ).replace('{reportId}', reportId);

  return axios
    .get(url)
    .then(res => {
      if (checkCancelToken(cancelTokenKey)) {
        dispatch({
          type: 'SUCCESS_API_GET_REPORT_DETAIL',
          payload: res.data,
        });
      }
      delCancelToken(cancelTokenKey);
      return res;
    })
    .catch(thrown => {
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch);
      }
      delCancelToken(cancelToken);
    });
};

export default getReportDetail;
